// prettier-ignore
export default {
    "admin_barcode": "/gestion/code-a-barres/",
    "upload_s3": "/api/storage/uploader/s3/",
    "imposition_prepress": "/modele/prepress/json/",
    "imposition_prepress_blank": "/modele/prepress_blank/json/",
    "upload_outfolders": "/api/storage/switch-outfolders/",
    "autocomplete": "/autocomplete/${name}/?v=2025.1205.0839",
    "notify_frontend_error": "/api/frontend-errors/"
} as const